import Text from 'components/Text/Text';
import React, { useContext } from 'react';
import Item from './components/Item';
import { IPushesViewContext, PushesViewContext } from '../../../../pushesViewContext/pushesViewState/pushesViewContext';
import classNames from 'classnames';
import style from './UpdateHistoryList.module.scss';

const UpdateHistoryList: React.FC = () => {
	const { softwareUpdates } = useContext<IPushesViewContext>(PushesViewContext);
	const nameHeadingClasses = classNames(style.name, style.heading);
	const lastUpdateHeadingClasses = classNames(style.lastUpdate, style.heading);
	const updatedByHeadingClasses = classNames(style.updatedBy, style.heading);
	const softwareTypeHeadingClasses = classNames(style.softwareType, style.heading);

	return (
		<div className={style.container} data-test="UpdateHistoryList">
			<div className={style.tableHeaders}>
				<Text
					className={nameHeadingClasses}
					translationNameSpace="form"
					translationKey="nameTableHeading"
					theme="neutralLight"
					withTooltip={true}
				/>
				<Text
					className={lastUpdateHeadingClasses}
					translationNameSpace="form"
					translationKey="lastUpdateTableHeading"
					theme="neutralLight"
					withTooltip={true}
				/>
				<Text
					className={updatedByHeadingClasses}
					translationNameSpace="form"
					translationKey="updatedByTableHeading"
					theme="neutralLight"
					withTooltip={true}
				/>
				<Text
					className={softwareTypeHeadingClasses}
					translationNameSpace="form"
					translationKey="softwareTypeTableHeading"
					theme="neutralLight"
					withTooltip={true}
				/>
			</div>
			{softwareUpdates.items.map((item, index) => (
				<Item data={item} key={item.id} index={index} />
			))}
		</div>
	);
};

export default UpdateHistoryList;
